import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export class BankTransferListItem extends SearchModelBase {
    postDate: string | null = null;
    fromPostDate: string | null = null;
    toPostDate: string | null = null;
    fBankName: string = '';
    fCurrency: string = '';
    fAmount: number|null = null;
    fromFAmount: number|null = null;
    toFAmount: number|null = null;
    tBankName: string = '';
    tCurrency: string = '';
    tAmount: number|null = null;
    fromTAmount: number|null = null;
    toTAmount: number|null = null;
    remark: string = '';
    transferFrom: string = '';
    transferTo: string = '';
    id: number = 0;
    u1Id: string = '';
    u1Date: string | null = null;
    fromU1Date: string | null = null;
    toU1Date: string | null = null;
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    u2Id: string = '';
    status: string = '';
    fBranch: string = '';
    tBranch: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Date', width: 75, dataIndex: 'postDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, defaultColumnFocus : true}),
        XCol.Create({ col: 2, text: 'From Bank', width: 120, dataIndex: 'fBankName'}),
        XCol.Create({ col: 3, text: 'BR', width: 40, dataIndex: 'fBranch', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'CUR', width: 40, dataIndex: 'fCurrency'}),
        XCol.Create({ col: 5, text: 'To Bank', width: 120, dataIndex: 'tBankName'}),
        XCol.Create({ col: 6, text: 'BR', width: 40, dataIndex: 'tBranch', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 7, text: 'CUR', width: 40, dataIndex: 'tCurrency'}),
        XCol.Create({ col: 8, text: 'Amount', width: 100, dataIndex: 'fAmount', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        // XCol.Create({ col: 7, text: 'Void', width: 40, dataIndex: 'void', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        XCol.Create({ col: 9, text: 'Remark', width: 150, dataIndex: 'remark'}),
        XCol.Create({ col: 10, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 11, text: 'Create by', width: 80, dataIndex: 'u1Id'}),
        XCol.Create({ col: 12, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 13, text: 'Update by', width: 80, dataIndex: 'u2Id'}),
        ];


    public static getExportCollection(useBranch: boolean): XCol.XExportColumn[] {
        let returnCloumns = _.cloneDeep(this.ExportCollection);
        if (!useBranch) {
            returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'fBranch' && x.dataIndex !== 'tBranch');
        }
        return returnCloumns;
    };
	
    public static OrderBy = { orderBy: BankTransferListItem.prototype.postDate, orderByAscending: false };

    public static formatData(data: BankTransferListItem[]) {
        return data.map((d: BankTransferListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        postDate: {from: 'fromPostDate', to: 'toPostDate'},
        fAmount: {from: 'fromFAmount', to: 'toFAmount'},
        tAmount: {from: 'fromTAmount', to: 'toTAmount'},
        u1Date: {from: 'fromU1Date', to: 'toU1Date'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
    }
}
